import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import ResendButton from './ResendButton';

const ResendButtonPicker = (props) => {
  const { challengeFlowCollection } = useIdentityChallengeContext();
  const [challengeFlowResource] = challengeFlowCollection;

  return pickFunction(challengeFlowResource, {
    [fr.relationships.resendMfaChallenge.name]: () => {
      return (
        <ResendButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default ResendButtonPicker;
